export { default as process } from 'node:process';
